import { ShowFeedbackDrawerFromTableOptions } from '@modules/quantify/components/QuantifyReportTableWidget/types';
import { CompareReportDataPoint } from '@modules/quantify/store/types';
import { Link, Tooltip } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import { ReactNode } from 'react';

interface renderCompareFieldColumnCellParams {
  params: GridRenderCellParams<CompareReportDataPoint, number, unknown>;
  onFeedbackCountClick: (params: ShowFeedbackDrawerFromTableOptions) => void;
  isCompareFieldA: boolean;
  tooltipTitle: ReactNode;
  skipDataPointFilter: boolean;
}

export const renderCompareFieldColumnCell = ({
  params,
  onFeedbackCountClick,
  isCompareFieldA,
  tooltipTitle,
  skipDataPointFilter,
}: renderCompareFieldColumnCellParams) => {
  if (!params.value) {
    return <>0</>;
  }

  return (
    <Tooltip
      arrow
      open={tooltipTitle ? undefined : false}
      title={tooltipTitle}
      placement="top"
      disableInteractive
    >
      <Link
        component="button"
        variant="body1"
        onClick={() =>
          onFeedbackCountClick({
            id: skipDataPointFilter ? '' : params.row.id,
            label: skipDataPointFilter ? '' : params.row.label,
            category: skipDataPointFilter ? undefined : params.row.category,
            isCompareFieldA,
            isInvisible: params.row.isInvisible,
            isUpdateInProgress: params.row.isUpdateInProgress,
          })
        }
        color="primary"
        underline="hover"
      >
        {params.value}
      </Link>
    </Tooltip>
  );
};
